export enum RouteName {
  List = 'blocking-rulesets',
}
